import { render, staticRenderFns } from "./clientInfoModalContent.vue?vue&type=template&id=2573697c&"
import script from "./clientInfoModalContent.vue?vue&type=script&lang=js&"
export * from "./clientInfoModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports